export default "/images/b0fd14f3342eda8f6b6ed967950d2f58.avif";